export default [
    {   //新品推荐列表
        path: "proddevelop/recommend/list",
        name: "recommendList",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/recommend/index"),
    },
    {   //新品推荐详情
        path: "proddevelop/recommend/update/:type",
        name: "recommendUpdate",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/recommend/update"),
    },
    {   //新品推荐列表
        path: "proddevelop/primary/list",
        name: "primaryList",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/primary/index"),
    },
    {   //新品推荐列表
        path: "proddevelop/primary/update/:type",
        name: "primaryUpdate",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/primary/update"),
    },
    // 推荐看板
    {   
        path: "proddevelop/recommend/menu",
        name: "primaryMenu",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/recommedmenu"),
    },

    // 预选看板
    {   
        path: "proddevelop/primary/menu",
        name: "primaryMenu",
        component: () => import(/* webpackChunkName: "proddevelop" */ "@/views/proddevelop/primarymenu"),
    },
]

